import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "******";

const SettingGatewaysForm = () => {
  const [apiSettings, setApiSettings] = useState({
    paytr_merchant_id: "",
    paytr_merchant_key: "",
    paytr_merchant_salt: "",
    paypal_api_username: "",
    paypal_api_password: "",
    paypal_api_signature: "",
    stripe_publishable_key: "",
    stripe_secret_key: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchApiData();
  }, []);

  // API verilerini çekme
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/settings/1`);
      console.log("Gelen API Data:", resp.data);
      const data = resp.data || {};
      
      // Hassas alanları maskeli hale getir
      const sensitiveFields = [
        "paytr_merchant_id",
        "paytr_merchant_key",
        "paytr_merchant_salt",
        "paypal_api_username",
        "paypal_api_password",
        "paypal_api_signature",
        "stripe_publishable_key",
        "stripe_secret_key"
      ];
      sensitiveFields.forEach((field) => {
        if (data[field] && data[field] !== "") {
          data[field] = MASK_VALUE;
        }
      });
      
      setApiSettings((prevState) => ({
        ...prevState,
        ...data,
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  // Input değişikliklerini handle etme
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Eğer kullanıcı "******" girmeye devam ediyorsa eski değeri koru
    setApiSettings((prev) => ({
      ...prev,
      [name]: value === MASK_VALUE ? prev[name] : value,
    }));
  };

  // Hassas alanlara odaklanıldığında maskeyi temizle
  const handleSecretFocus = (e) => {
    if (e.target.value === MASK_VALUE) {
      e.target.value = "";
      setApiSettings((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
    }
  };

  // Kaydet butonuna basınca API'yi güncelle
  const handleSave = async () => {
    try {
      // Backend'e gönderilecek veriyi hazırlarken,
      // eğer kullanıcı değeri değiştirmediyse (masked değeri halen varsa) o alanı gönderme.
      const sensitiveFields = [
        "paytr_merchant_id",
        "paytr_merchant_key",
        "paytr_merchant_salt",
        "paypal_api_username",
        "paypal_api_password",
        "paypal_api_signature",
        "stripe_publishable_key",
        "stripe_secret_key"
      ];
      const dataToSave = { ...apiSettings };

      sensitiveFields.forEach((field) => {
        if (dataToSave[field] === MASK_VALUE) {
          delete dataToSave[field];
        }
      });

      await axios.put(`${BASE_URL}/api/settings/1`, dataToSave);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          {/* PAYTR SETTINGS CARD */}
          <div className="card card-body mb-4">
            <h5 className="fw-bold text-primary">{getText("LABEL_PAYTR_SETTINGS")}</h5>
            {["paytr_merchant_id", "paytr_merchant_key", "paytr_merchant_salt"].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form-label fw-bold">
                  {getText(`LABEL_${field.toUpperCase()}`, field.replace(/_/g, " ").toUpperCase())}
                </label>
                <input
                  type="password"
                  className="form-control"
                  name={field}
                  value={apiSettings[field] || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  placeholder={MASK_VALUE}
                  autoComplete="off"
                />
              </div>
            ))}
          </div>

          {/* PAYPAL SETTINGS CARD */}
          <div className="card card-body mb-4">
            <h5 className="fw-bold text-primary">{getText("LABEL_PAYPAL_SETTINGS")}</h5>
            {["paypal_api_username", "paypal_api_password", "paypal_api_signature"].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form-label fw-bold">
                  {getText(`LABEL_${field.toUpperCase()}`, field.replace(/_/g, " ").toUpperCase())}
                </label>
                <input
                  type="password"
                  className="form-control"
                  name={field}
                  value={apiSettings[field] || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  placeholder={MASK_VALUE}
                  autoComplete="off"
                />
              </div>
            ))}
          </div>

          {/* STRIPE SETTINGS CARD */}
          <div className="card card-body mb-4">
            <h5 className="fw-bold text-primary">{getText("LABEL_STRIPE_SETTINGS")}</h5>
            {["stripe_publishable_key", "stripe_secret_key"].map((field) => (
              <div className="mb-3" key={field}>
                <label className="form-label fw-bold">
                  {getText(`LABEL_${field.toUpperCase()}`, field.replace(/_/g, " ").toUpperCase())}
                </label>
                <input
                  type="password"
                  className="form-control"
                  name={field}
                  value={apiSettings[field] || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  placeholder={MASK_VALUE}
                  autoComplete="off"
                />
              </div>
            ))}
          </div>

          {/* KAYDET BUTONU */}
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary" onClick={handleSave}>
              <FiSave className="me-2" /> {getText("SAVE_BTN")}
            </button>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingGatewaysForm;
